import { MARKETING_URL } from '../../constants'

export function Footer() {
  // Derived, not a literal — a hardcoded year silently goes stale (issue #239).
  const year = new Date().getFullYear()

  return (
    <footer className="border-t border-[var(--color-border)] bg-[var(--color-background)]">
      <div className="container py-8 px-4">
        <div className="flex flex-col items-center justify-between space-y-4 md:flex-row md:space-y-0">
          <div className="flex flex-col items-center space-y-2 md:flex-row md:space-y-0 md:space-x-4">
            <p className="text-sm text-[var(--color-text-secondary)]">
              © {year} Shoots. All rights reserved.
            </p>
          </div>
          <div className="flex items-center space-x-4">
            <a
              href={`${MARKETING_URL}/privacy-policy`}
              rel="noopener noreferrer"
              className="text-sm text-[var(--color-text-secondary)] hover:text-[var(--color-text-primary)]"
            >
              Privacy
            </a>
            <a
              href={`${MARKETING_URL}/terms-of-service`}
              rel="noopener noreferrer"
              className="text-sm text-[var(--color-text-secondary)] hover:text-[var(--color-text-primary)]"
            >
              Terms
            </a>
          </div>
        </div>
      </div>
    </footer>
  )
}
